export default __webpack_public_path__ + "static/50-dd544974f2bcc1156a08458595b36519.png";